<div class="cert-table card card--no-padding">
  <div class="table-wrapper">
    <table matSort matSortActive="recordedAt" matSortDirection="desc" (matSortChange)="sortData($event)">
      <thead>
        <tr>
          <th mat-sort-header="ipAddress">
            <div>
              <span>{{ "Cert.IPAddress" | translate }}</span>
            </div>
          </th>
          <th mat-sort-header="rpzFeed">
            <div>
              <span>{{ "Cert.RPZFeed" | translate }}</span>
            </div>
          </th>
          <th mat-sort-header="hit">
            <div>
              <span>{{ "Cert.Hit" | translate }}</span>
            </div>
          </th>
          <th mat-sort-header="recordedAt">
            <div>
              <span>{{ "Cert.RecordedAt" | translate }} (UTC)</span>
            </div>
          </th>
          <th mat-sort-header="resolver">
            <div>
              <span>{{ "Cert.Resolver" | translate }}</span>
            </div>
          </th>
          <th mat-sort-header="action">
            <div>
              <span>{{ "Cert.Action" | translate }}</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (item of dnsFirewallLogs(); track $index) {
          @let node = item.node;
          <tr>
            <td>{{ node?.ipAddress }}</td>
            <td>{{ node?.rpzFeed }}</td>
            <td>{{ node?.hit }}</td>
            <td>{{ node?.recordedAt }}</td>
            <td>{{ node?.resolver }}</td>
            <td>{{ node?.action }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="table-bottom">
    @if (emptyResult()) {
      <div>
        <p>{{ "Global.NoResults" | translate }}</p>
      </div>
    }
    <pagination
      [paginationStyle]="paginationStyle"
      [pageInfo]="pageInfo()"
      (paginationChanged)="onPaginationChanged($event)"
      (pageSizeChanged)="onPageSizeChanged($event)"
    ></pagination>
  </div>
</div>
